import PositionCluster from "@/views/MGT/position/components/position-cluster.vue";
import PositionList from "@/views/MGT/position/components/position-list.vue";
export default {
  name: "position",
  components: {
    PositionCluster,
    PositionList
  },
  data() {
    return {
      position: {},
      searchValue: ""
    };
  },
  methods: {
    onChange(position) {
      this.position = position;
    },
    onSearch(val) {
      this.searchValue = val;
    },
    onAddPosition() {
      this.$refs["positionClusterRef"].onAdd();
    }
  }
};